import '@fontsource-variable/archivo';
import { bootstrapVariantApp } from '@shared/app/bootstrap';
import './theme/theme.css';
import { innovasjonNorgeVariantConfig } from './variant';

bootstrapVariantApp(innovasjonNorgeVariantConfig);
